<template>
  <div v-if="visible" style="background-color:#000;">
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title=""
      :visible.sync="dialogVisible"
      class="qrcode__wrapper"
    >
      <div class="qrcode__main-container">
        <template v-if="loading">
          <p>加载中</p>
        </template>
        <template v-else>
          <div class="header">识别图中二维码支付<br>{{parseCountDown(rest)}}后二维码失效</div>
          <div class="main">
            <img :src="src" alt="" />
            <div class="pyatitle">请用手机摄像头扫描二维码进行支付<br>（仅支持微信支付）</div>
            <div v-if="refresh && !isPay" class="refresh__bt" @click="onRefresh"></div>
            <div v-else-if="refresh && isPay" class="payed"><p>支付成功<br/>即将自动跳转<br/>请勿刷新本页</p></div>
          </div>
          <div class="jj"></div>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pay, orderQuery } from '@/api/user';

let wrapperZindex;
let footerZindex;

export default {
  name: 'pay-qrcode',
  props: {
    body: {
      type: String,
      default: '',
    },
    price: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    afterPay: {
      type: Function,
      default: undefined,
    },
  },
  data() {
    return {
      src: '',
      deadline: '',
      loading: false,
      orderNum: undefined,
      dialogVisible: false,
      clock: '',
      rest: 0,
      refresh: false,
      isPay: false,
    };
  },
  watch: {
    visible(val) {
      if (val) this.init();
    },
    dialogVisible(val) {
      document.querySelector('.base-bone__wrapper').style.zIndex = val ? 'auto' : wrapperZindex;
      document.querySelector('.footer-wrapper-container').style.zIndex = val ? '-1' : footerZindex;
      if (val === false) {
        this.onClose();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      wrapperZindex = window.getComputedStyle(document.querySelector('.base-bone__wrapper')).zIndex;
      footerZindex = window.getComputedStyle(document.querySelector('.footer-wrapper-container'))
        .zIndex;
    });
  },
  methods: {
    now() {
      return Math.floor(new Date().getTime() / 1000);
    },
    init() {
      const that = this;
      that.loading = true;
      that.dialogVisible = true;
      that.rest = 0;
      that.getCode();
    },
    getCode() {
      const that = this;
      pay({
        body: that.body,
        price: that.price,
      })
        .then((res) => {
          const { data } = res;
          that.src = data.url;
          that.orderNum = data.orderNum;
          that.deadline = data.outTime;
          // 开始倒计时
          that.countDown();
        })
        .finally(() => {
          that.loading = false;
        });
    },
    onClose() {
      window.clearInterval(this.clock);
      this.$emit('update:visible', false);
    },
    countDown() {
      const that = this;
      that.rest = that.deadline - that.now();
      that.refresh = false;
      that.clock = window.setInterval(() => {
        that.rest -= 1;
        that.payQuery();
        if (this.isPay || that.rest < 0) {
          window.clearInterval(that.clock);
          that.refresh = true;
          // 完成支付
          if (that.isPay) that.$emit('afterPay', that.orderNum);
        }
      }, 1000);
    },
    onRefresh() {
      this.getCode();
    },
    parseCountDown(val) {
      let m = Math.floor(val / 60);
      m = m < 10 ? `0${m}` : m;
      let s = val % 60;
      s = s < 10 ? `0${s}` : s;
      return `${m}:${s}`;
    },
    payQuery() {
      const that = this;
      if (!that.isPay && that.orderNum) {
        orderQuery({
          orderNum: that.orderNum,
        }).then((res) => {
          that.isPay = res;
        });
      }
    },
  },
};
</script>

<style>
  .pyatitle{
    color: red;
    font-size: 16px;
  }
  .jj{
    height: 30px;
  }
</style>
